import React from 'react';
import { CtaButton } from './CtaButton';
import { PriceDisplay } from './PriceDisplay';
export function HeroSection() {
  return <section className="bg-gradient-to-br from-[#FFF3E0] via-light-bg to-[#E8F5E9] text-center py-12 md:py-16 px-5 border-b-4 border-accent" data-id="element-249">
      <div className="max-w-4xl mx-auto" data-id="element-250">
        <p className="font-sans text-sm md:text-base uppercase tracking-[3px] text-primary font-bold mb-3" data-id="element-251">
          Presentamos la Guía Más Completa de Habla Hispana
        </p>

        <h1 className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-[44px] leading-tight font-black text-dark max-w-3xl mx-auto mb-3" data-id="element-252">
          Más de{' '}
          <span className="text-primary text-[1.15em]" data-id="element-253">1.000 Actividades</span>{' '}
          de Estimulación Temprana
          <br className="hidden sm:block" data-id="element-254" />
          Para Cada Mes de Vida (de 0 a 5 años)
        </h1>

        <p className="font-sans text-lg md:text-xl text-gray-600 max-w-2xl mx-auto mb-7" data-id="element-255">
          Paso a paso. Sin pantallas. Sin complicaciones. Desde casa y en solo
          10 minutos al día.
        </p>

        <div className="bg-dark text-gray-400 max-w-2xl mx-auto mb-6 py-10 px-5 rounded-xl" data-id="element-256">
          <p className="font-sans text-sm mb-4" data-id="element-257">
            (Asegúrate de tener el sonido activado. El vídeo puede tardar unos
            segundos en cargar)
          </p>
          <p className="text-4xl mb-4" data-id="element-258">▶</p>
          <p className="font-sans text-base text-gray-300" data-id="element-259">
            Mira Este Vídeo Hasta el Final y Obtén Acceso al Pack Completo
          </p>
        </div>

        <div className="font-sans text-base md:text-lg text-gray-600 mb-4" data-id="element-260">
          Oferta por Tiempo Limitado:{' '}
          <PriceDisplay amount={36} className="line-through text-gray-400" data-id="element-261" />{' '}
          <PriceDisplay amount={12.99} className="text-primary font-black text-2xl md:text-3xl ml-2" data-id="element-262" />
        </div>

        <div className="my-8" data-id="element-263">
          <CtaButton subtitle="Acceso Inmediato a +1.000 Actividades >>" data-id="element-264">
            Añadir Al Carrito
          </CtaButton>
        </div>

        <p className="font-sans text-sm text-gray-500 max-w-lg mx-auto" data-id="element-265">
          Pago único. Sin suscripciones. Sin cargos ocultos.
          <br data-id="element-266" />
          Me reservo el derecho de cerrar esta oferta en cualquier momento
          después del 25 de febrero de 2026.
        </p>
      </div>
    </section>;
}